var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 24.0013C11.7625 24.0013 12.4938 23.6852 13.0329 23.1226C13.5721 22.56 13.875 21.797 13.875 21.0013H8.125C8.125 21.797 8.4279 22.56 8.96707 23.1226C9.50624 23.6852 10.2375 24.0013 11 24.0013ZM12.4303 1.64981C12.4504 1.44124 12.4283 1.2306 12.3656 1.03147C12.3028 0.832343 12.2008 0.649147 12.066 0.493699C11.9313 0.338252 11.7668 0.214004 11.5831 0.128969C11.3995 0.0439342 11.2009 0 11 0C10.7991 0 10.6005 0.0439342 10.4169 0.128969C10.2332 0.214004 10.0687 0.338252 9.93398 0.493699C9.79922 0.649147 9.69717 0.832343 9.63442 1.03147C9.57168 1.2306 9.54962 1.44124 9.56969 1.64981C7.94491 1.99466 6.48427 2.91485 5.4351 4.25456C4.38593 5.59427 3.81271 7.27117 3.8125 9.00131C3.8125 10.6483 3.09375 18.0013 0.9375 19.5013H21.0625C18.9062 18.0013 18.1875 10.6483 18.1875 9.00131C18.1875 5.37131 15.715 2.34131 12.4303 1.64981Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.32666ae747011af479529c43c51e76b2.svg";
export { ForwardRef as ReactComponent };